import * as String from "@/helper/String"
import _ from "lodash";
import {arrayIsNotEmpty} from "@/helper/Array";
import {SEARCH_TYPE__STARTS_WITH} from "@/helper/characteristic/edit/SearchType";

export function search (characteristic, keyword, type)
{
	let found = searchByType(characteristic.label, keyword, type)
		|| searchByType(characteristic.description || '', keyword, type);

	if (found)
	{
		return true;
	}

	if (arrayIsNotEmpty(characteristic.variants))
	{
		let variantHit = false;

		_.forEach(characteristic.variants, variant =>
		{
			if (searchByType(variant, keyword, type))
			{
				variantHit = true;

				return false; // break;
			}
		});

		if (variantHit)
		{
			return true;
		}
	}

	return false;
}

function searchByType(text, keyword, type)
{
	return type === SEARCH_TYPE__STARTS_WITH
		? String.startsWith(text, keyword)
		: String.search(text, keyword);
}
